/* oxlint-disable formatjs/no-literal-string-in-jsx */
import { Button } from '@repo/design-system-kit/components/button/button';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import { Popup } from '@repo/design-system-kit/components/popup/popup';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import generalApproval from '@repo/visual-assets/dotlottie/lottie_pop_general_sca_approval.lottie';
import styles from './mfa.module.css';

interface PhoneNumberProps {
  onClose?: () => void;
  onVerifyNumber: () => void;
  phoneNumber: string;
}

export function PhoneNumber({
  onClose,
  onVerifyNumber,
  phoneNumber,
}: PhoneNumberProps): React.ReactNode {
  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();
  const handleClose = (): void => {
    onClose?.();
    setIsOpen(false);
  };

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'otp.sms_title' })}
      data-testid="mfa-phone-number"
      isOpen={isOpen}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure className={styles.illustrationWrap}>
          <LottiePlayer className={styles.illustration} src={generalApproval} />
        </figure>
        <Popup.Title>
          <FormattedMessage id="otp.sms_title" />
        </Popup.Title>
        <Popup.Subtitle>
          <FormattedMessage id="otp.sms_subtitle" />
        </Popup.Subtitle>
      </Popup.Header>
      <Popup.Body>
        <p className="body-standard">
          <FormattedMessage id="labels.phone" />
          &nbsp;
          <strong>{phoneNumber}</strong>
        </p>
      </Popup.Body>
      <Popup.Footer>
        <Button onPress={handleClose} variant="secondary">
          <FormattedMessage id="sca.btn.back" />
        </Button>
        <Button data-testid="verify-phone-number" onPress={onVerifyNumber} variant="primary">
          <FormattedMessage id="sca.btn.verify_phone_number" />
        </Button>
      </Popup.Footer>
    </Popup.Root>
  );
}
